__turbopack_context__.v({
  "loader": "lomBwq_loader",
  "spin": "lomBwq_spin",
});
